// 支付相关翻译

export const payment = {
    selectMethod: '選擇支付方式',
    orderSummary: '訂單摘要',
    choosePaymentMethod: '選擇您偏好的支付方式',
    creditCard: '信用卡/借記卡',
    creditCardDescription: '通過 Stripe 安全地使用您的信用卡或借記卡支付',
    paypalDescription: '使用您的 PayPal 帳戶或 PayPal 餘額支付',
    securityNote: '您的支付信息已加密並且安全',
    processing: '正在處理支付...',
    paymentFailed: '支付失敗，請重試。',
    paymentCancelled: '支付已取消。',
    invalidPaymentMethod: '選擇的支付方式無效。',
    networkError: '網絡錯誤，請檢查您的連接並重試。',
    paypalPayment: 'PayPal 支付',
    loadingPayPal: '正在載入 PayPal...',
    paypalSecurityNote: '您的支付由 PayPal 安全處理',
    
    // 支付状态轮询翻译
    poller: {
      success: '支付成功完成',
      processing: '支付已確認，正在處理積分...',
      failed: '支付失敗',
      unknown: '未知支付狀態',
      error: '檢查支付狀態時出錯',
      network_error: '檢查支付狀態時網絡錯誤',
      starting: '開始支付驗證...',
      timeout: '支付驗證超時',
      quickSuccess: '支付成功！正在處理您的積分...',
      // 新增的翻译键
      offline: '網絡連接中斷',
      auth_error: '身份驗證失敗',
      not_found: '找不到訂單',
      server_error: '服務器錯誤，正在重試...',
      invalid_data: '無效的響應數據',
      invalid_status: '無效的支付狀態',
      invalid_order: '無效的訂單ID'
    },
    
    // 支付成功页面翻译
    success: {
      title: '支付成功！',
      message: '感謝您的支付。您的交易已成功完成。',
      description: '您現在可以享受所有高級功能。',
      continue: '繼續到儀表板'
    },
    
    // 支付回调页面翻译
    callback: {
      cancelled: '用戶取消了支付',
      missingParams: '缺少支付參數',
      success: '支付成功完成',
      failed: '支付處理失敗',
      timeout: '支付仍在處理中。請稍後檢查您的帳戶。',
      verificationFailed: '支付驗證失敗',
      error: '驗證支付失敗。請聯繫客服。',
      transactionId: '交易ID',
      status: '狀態',
      quickSuccess: '支付成功！您的積分正在處理中，稍後將可用。',
      
      processing: {
        title: '正在處理支付',
        message: '請稍候，我們正在驗證您的支付...',
        webhook: '支付已完成，正在處理您的訂單...'
      },
      
      quickSuccessDetails: {
        title: '支付成功！',
        processing: '積分正在添加到您的帳戶...',
        continue: '繼續到儀表板'
      },
      
      successDetails: {
        title: '支付成功！',
        message: '感謝您的支付。您的交易已成功完成。',
        description: '您現在可以享受所有高級功能。',
        continue: '繼續到儀表板'
      },
      
      cancelledDetails: {
        title: '支付已取消',
        message: '您的支付已取消。您的帳戶未被收取任何費用。',
        description: '您可以重試或選擇不同的支付方式。',
        continue: '返回定價頁面'
      },
      
      errorDetails: {
        title: '支付錯誤',
        message: '檢查支付狀態時發生過多錯誤。',
        description: '請重試或聯繫客服。'
      },
      
      timeoutDetails: {
        title: '支付處理中',
        description: '您的支付可能仍在處理中。請幾分鐘後檢查您的帳戶，或如有需要請聯繫客服。',
        continue: '前往儀表板'
      },
      
      failedDetails: {
        title: '支付失敗',
        description: '請重試或聯繫我們的客服團隊，如果問題持續存在。',
        continue: '返回定價頁面'
      }
    }
  };
